/**
 * El enlace del banner se carga en el admin para web y app: URL, ruta ("/promociones"),
 * nombre de pantalla ("jugar") o JSON de deep link ({"action":"navigate","screen":"jugar"}).
 * Devuelve { href, external } para la web, o null si no lleva a ningún lado.
 */
const SCREENS = {
  jugar: "/apuestas",
  apuestas: "/apuestas",
  home: "/welcome",
  inicio: "/welcome",
  resultados: "/resultados",
  promociones: "/promociones",
  blog: "/blog",
  registro: "/auth",
  register: "/auth",
  perfil: "/perfil",
  historial: "/perfil",
  recargar: "/perfil",
  ayuda: "/ayuda",
};

export function bannerHref(link) {
  let value = String(link || "").trim();
  if (!value) return null;
  if (value.startsWith("{")) {
    try {
      const parsed = JSON.parse(value);
      value = String(parsed.url || parsed.screen || parsed.route || "").trim();
    } catch {
      return null;
    }
    if (!value) return null;
  }
  if (/^https?:\/\//i.test(value)) {
    try {
      const u = new URL(value);
      if (typeof window !== "undefined" && u.host === window.location.host) {
        return { href: `${u.pathname}${u.search}${u.hash}`, external: false };
      }
    } catch {
      return null;
    }
    return { href: value, external: true };
  }
  if (value.startsWith("/")) return { href: value, external: false };
  const route = SCREENS[value.toLowerCase()];
  return route ? { href: route, external: false } : null;
}
